// :cow: Cosmose CONFIDENTIAL :iso:
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LoginPayload } from '@coa/app/libs/auth/auth-module/models/login-payload';

@Component({
  selector: 'lib-auth-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnChanges {

  @Input() isCodeRequired = false;
  @Input() resetPasswordLink: string;
  @Output() credentialsSubmitted = new EventEmitter<LoginPayload>();

  formGroup: FormGroup;
  usernameFormControl = new FormControl('', [Validators.required]);
  passwordFormControl = new FormControl('', [Validators.required]);
  codeFormControl = new FormControl('');

  constructor(
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnChanges(): void {
    if (this.isCodeRequired) {
      this.codeFormControl.setValidators([Validators.required, Validators.minLength(6)]);
    } else {
      this.codeFormControl.clearValidators();
    }
    this.cdr.detectChanges();
  }

  ngOnInit(): void {
    this.formGroup = new FormGroup({
      username: this.usernameFormControl,
      password: this.passwordFormControl,
      code: this.codeFormControl,
    });
    this.cdr.detectChanges();
  }

  login() {
    if (this.formGroup.invalid) {
      return;
    }

    this.credentialsSubmitted.emit(this.formGroup.value);
    this.cdr.detectChanges();
  }

  showFirstStepForm(): void {
    this.isCodeRequired = false;
    this.cdr.detectChanges();
  }
}
